import { Button } from '@mui/material';
import { MY } from 'config/fe-routes';
import moment from 'moment';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { UserType } from 'types/user.types';
import formatDate from 'utils/format-date';
import { redirectTo } from 'utils/route-helpers';

import Modal from '../Modal/Modal';

type Props = {
  isOpen: boolean;
  dac7RequiredAt: UserType['dac7_required_at'];
  closeModal: () => void;
};

export const Dac7Modal = (props: Props) => {
  const { closeModal, isOpen, dac7RequiredAt } = props;
  const { t } = useTranslation();
  let deadlineInfo = '';

  if (dac7RequiredAt) {
    const deadlineWarningAt = moment(dac7RequiredAt).add(30, 'days').toDate();
    const deadlineOverdueAt = moment(dac7RequiredAt).add(60, 'days').toDate();

    if (new Date() > deadlineOverdueAt) {
      deadlineInfo = t('dac7-modal.info-deadline-overdue');
    } else if (new Date() > deadlineWarningAt) {
      deadlineInfo = t('dac7-modal.info-deadline-upcoming', {
        deadlineDate: formatDate(deadlineOverdueAt),
        deadlineDaysLeft: moment(deadlineOverdueAt).diff(moment(), 'days'),
      });
    }
  }

  return (
    <Modal
      open={isOpen}
      onClose={() => closeModal()}
      className="dac7-modal"
      title="dac7-modal.title"
      titleUnderline={true}
      actionsTopBorderline={true}
      closeButtonVisible={false}
      maxWidth={'xs'}
      actions={[
        <div key="modal-action-button" className="dac7-btn-container" style={{ paddingTop: '16px' }}>
          <Button
            style={{
              textTransform: 'none',
              marginRight: '8px',
            }}
            variant="contained"
            color="primary"
            onClick={() => redirectTo(MY.SETTINGS_PROFILE_DAC7())}
          >
            {t('dac7-modal.fill-form')}
          </Button>
          <Button
            style={{
              textTransform: 'none',
            }}
            variant="outlined"
            color="primary"
            onClick={() => closeModal()}
          >
            {t('dac7-modal.remind-me-later')}
          </Button>
        </div>,
      ]}
    >
      <div>{t('dac7-modal.info-1')}</div>
      <div style={{ paddingTop: '16px' }}>{t('dac7-modal.info-2')}</div>
      <div style={{ paddingTop: '16px' }}>{t('dac7-modal.info-3')}</div>
      {deadlineInfo && <div style={{ paddingTop: '16px' }}>{deadlineInfo}</div>}
      <div style={{ paddingTop: '16px', color: '#ff7d6b' }}>
        <a
          href={t('dac7-modal.more-info-link')}
          style={{ padding: '0px', fontSize: '16px', fontWeight: 'normal', color: '#ff7d6b', textDecoration: 'none' }}
        >
          {t('dac7-modal.more-info')}
        </a>
      </div>
    </Modal>
  );
};
